<template>
  <div class="flightDetailRealTimeContainer" id="flightDetailRealTimeContainer">
    <div class="titleContainer">
      <div class="row">
        <label class="name">飞机型号:&nbsp;</label
        ><label class="content">{{ taskPlan.uasTypeName }}</label>
      </div>
      <div class="row">
        <label class="name">飞机编号:&nbsp;</label
        ><label class="content">{{ taskPlan.uasSerialId }}</label>
      </div>
      <div class="statusContainer">
        <div class="circle"></div>
        <label>未开始</label>
      </div>
    </div>
    <div class="separator"></div>
    <div class="chartMainContainer">
      <div class="headerInfoContainer">
        <div class="leftInfoContainer">
          <div class="title">飞行速度m/s</div>
          <div class="content"></div>
        </div>
        <div class="centerInfoContainer">
          <div class="column">
            <div class="title">滚转</div>
            <div class="content">{{ currentPoint.roll }}°</div>
          </div>
          <div class="column">
            <div class="title">偏航</div>
            <div class="content">{{ currentPoint.heading }}°</div>
          </div>
          <div class="column">
            <div class="title">俯仰</div>
            <div class="content">{{ currentPoint.pitch }}°</div>
          </div>
        </div>
        <div class="rightInfoContainer">
          <div class="title">相对高度m</div>
          <div class="content"></div>
        </div>
      </div>
      <div class="centerChartContainer">
        <img :src="leftScale" class="leftScale" />
        <div class="centerDashboardContainer">
          <canvas id="dashboardChart" class="dashboardChart" width="199" height="286" />
          <img
            id="dashboardScale"
            src="../../../assets/img/home/flightDetail/dashboardScale.png"
            style="display: none"
          />
          <img
            id="headingScale"
            src="../../../assets/img/home/flightDetail/headingScale.png"
            style="display: none"
          /><img
            id="headingFlight"
            src="../../../assets/img/home/flightDetail/headingFlight.png"
            style="display: none"
          /><img
            id="pitch"
            src="../../../assets/img/home/flightDetail/pitch.png"
            style="display: none"
          /><img
            id="pointer"
            src="../../../assets/img/home/flightDetail/pointer.png"
            style="display: none"
          /><img
            id="rudder"
            src="../../../assets/img/home/flightDetail/rudder.png"
            style="display: none"
          />
          <label>偏航:&nbsp;东南</label>
        </div>
        <img :src="rightScale" class="rightScale" />

        <div class="leftAxisContainer axisContainer">
          <div class="axis">{{ leftAxis[7] }}</div>
          <div class="axis">{{ leftAxis[6] }}</div>
          <div class="axis">{{ leftAxis[5] }}</div>
          <div class="axis">{{ leftAxis[4] }}</div>
          <div class="axis">{{ leftAxis[3] }}</div>
          <div class="axis">{{ leftAxis[2] }}</div>
          <div class="axis">{{ leftAxis[1] }}</div>
          <div class="axis">{{ leftAxis[0] }}</div>
        </div>

        <div class="leftTargetAxis">目标 {{ leftAxis[4] }}</div>
        <div id="leftRealAxis" class="leftRealAxis">实时 {{ speed }}</div>

        <div class="rightAxisContainer axisContainer">
          <div class="axis">{{ rightAxis[7] }}</div>
          <div class="axis">{{ rightAxis[6] }}</div>
          <div class="axis">{{ rightAxis[5] }}</div>
          <div class="axis">{{ rightAxis[4] }}</div>
          <div class="axis">{{ rightAxis[3] }}</div>
          <div class="axis">{{ rightAxis[2] }}</div>
          <div class="axis">{{ rightAxis[1] }}</div>
          <div class="axis">{{ rightAxis[0] }}</div>
        </div>
        <div class="rightTargetAxis">{{ rightAxis[4] }} 目标</div>
        <div id="rightRealAxis" class="rightRealAxis">{{ height }} 实时</div>
      </div>
      <div class="footerInfoContainer">
        <div class="leftInfoContainer">
          <div class="title">相对地面速度</div>
          <div class="content">{{ currentPoint.groundSpeed }}km/h</div>
        </div>
        <div class="centerInfoContainer">
          <div class="title">空速</div>
          <div class="content">{{ currentPoint.trueAirspeed }}km/h</div>
        </div>
        <div class="rightInfoContainer">
          <div class="title">平均海拔高度</div>
          <div class="content">{{ currentPoint.groundAlt }}m</div>
        </div>
      </div>
    </div>
    <div class="separator"></div>
    <div class="realTimeInfoContainer">
      <div class="leftContainer">
        <div class="row">
          <div class="title">剩余里程</div>
          <div class="content">{{ currentPoint.remainingDis }}km</div>
        </div>
        <div class="row">
          <div class="title">温度</div>
          <div class="content">{{ currentPoint.temperature }}°</div>
        </div>
        <div class="row">
          <div class="title">动力系统</div>
          <div class="content">{{ currentPoint.motStatusName }}</div>
        </div>
      </div>
      <div class="centerContainer">
        <div class="row">
          <div class="title">剩余电量(油量)</div>
          <div class="content">{{ currentPoint.remainingOil }}%</div>
        </div>
        <div class="row">
          <div class="title">风速</div>
          <div class="content">{{ currentPoint.windSpeed }}km/h</div>
        </div>
        <div class="row">
          <div class="title">导航系统</div>
          <div class="content">{{ currentPoint.navStatusName }}</div>
        </div>
      </div>
      <div class="rightContainer">
        <div class="row">
          <div class="title">剩余时间</div>
          <div class="content">{{ currentPoint.remainingTime }}min</div>
        </div>
        <div class="row">
          <div class="title">链路类型</div>
          <div class="content">{{ taskPlan.airLinkName }}</div>
        </div>
        <div class="row">
          <div class="title">通信系统</div>
          <div class="content">{{ currentPoint.comStatusName }}</div>
        </div>
      </div>
    </div>
    <div class="separator"></div>
    <div class="operationContainer" v-show="!isHistory">
      <div class="column">
        <div class="unlockContainer">
          <img :src="unlockImg" class="unlockImg" @click="unlock" />
          <label>解锁</label>
        </div>
        <div class="takeOffContainer">
          <img :src="takeOffImg" class="takeOffImg" @click="takeOff" />
          <label>起飞</label>
        </div>
      </div>
      <div class="column second">
        <div class="alternateLandContainer">
          <img :src="alternateLandImg" class="alternateLandImg" @click="alternateLand" />
          <label>备降</label>
        </div>
        <div class="returnContainer">
          <img :src="returnImg" class="returnImg" @click="uavReturn" />
          <label>返航</label>
        </div>
      </div>
      <div class="column third">
        <div class="landContainer">
          <img :src="landImg" class="landImg" @click="land" />
          <label>降落</label>
        </div>
        <div class="hoverContainer">
          <img :src="hoverImg" class="hoverImg" @click="hover" />
          <label>悬停/盘旋</label>
        </div>
      </div>
      <div class="column fouth">
        <div class="cruiseContainer">
          <img :src="cruiseImg" class="cruiseImg" @click="cruise" />
          <label>巡航</label>
        </div>
        <div class="airdropContainer">
          <img :src="airdropImg" class="airdropImg" @click="airdrop" />
          <label>空投</label>
        </div>
      </div>
    </div>
    <div class="replayBackOptContainer" v-show="isHistory">
      <div class="leftContainer">
        <div class="endImg" @click="endFly" />
        <label>停止</label>
      </div>
      <div class="centerContainer">
        <div class="playImg" :class="{ isStop: playOrPause }" @click="pauseOrPlay" />
        <label>{{ playOrPauseName }}</label>
      </div>
      <div class="rightContainer">
        <div
          class="speedImg"
          :class="{
            speedImg1: replaySpeed === 1,
            speedImg2: replaySpeed === 2,
            speedImg3: replaySpeed === 3,
          }"
          @mouseenter="selectSpeedBgShow = true"
          @mouseleave="selectSpeedBgShow = false"
        />
        <label>倍速</label>
        <div
          class="selectSpeedMainContainer"
          @mouseenter="selectSpeedBgShow = true"
          @mouseleave="selectSpeedBgShow = false"
          v-show="selectSpeedBgShow"
        >
          <div class="selectSpeedContainer">
            <label :class="{ selectSpeedLabelOne }" @click="setSpeed(1)">1.0X</label>
            <label :class="{ selectSpeedLabelTwo }" @click="setSpeed(2)">2.0X</label>
            <label :class="{ selectSpeedLabelThree }" @click="setSpeed(3)">3.0X</label>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script type="text/javascript">
import cloudy from "../../../assets/img/home/flightDetail/cloudy.png";
import unlockImg from "../../../assets/img/home/flightDetail/unlockImg.png";
import takeOffImg from "../../../assets/img/home/flightDetail/takeOffImg.png";
import alternateLandImg from "../../../assets/img/home/flightDetail/alternateLandImg.png";
import returnImg from "../../../assets/img/home/flightDetail/returnImg.png";
import landImg from "../../../assets/img/home/flightDetail/landImg.png";
import hoverImg from "../../../assets/img/home/flightDetail/hoverImg.png";
import cruiseImg from "../../../assets/img/home/flightDetail/cruiseImg.png";
import airdropImg from "../../../assets/img/home/flightDetail/airdropImg.png";
import leftScale from "../../../assets/img/home/flightDetail/leftScale.png";
import rightScale from "../../../assets/img/home/flightDetail/rightScale.png";
import speedImg1 from "../../../assets/img/home/flightDetail/speedImg1.png";
import speedImg2 from "../../../assets/img/home/flightDetail/speedImg2.png";
import speedImg3 from "../../../assets/img/home/flightDetail/speedImg3.png";

export default {
  name: "flightDetailRealTime",
  data() {
    return {
      initFlag: false,
      dashboardScaleFlag: false,
      headingScaleFlag: false,
      headingFlightFlag: false,
      pitchFlag: false,
      pointerFlag: false,
      rudderFlag: false,
      selectSpeedBgShow: false, //是否显示速度选择背景
      heading: 180,
      roll: 0,
      pitch: 0,
      type1: "reduce",
      type2: "reduce",
      type3: "reduce",
      leftAxis: [0, 5, 10, 15, 20, 25, 30, 35],
      rightAxis: [0, 200, 400, 600, 800, 1000, 1200, 1400],
      weatherIcon: cloudy,
      unlockImg: unlockImg,
      takeOffImg: takeOffImg,
      alternateLandImg: alternateLandImg,
      returnImg: returnImg,
      landImg: landImg,
      hoverImg: hoverImg,
      cruiseImg: cruiseImg,
      airdropImg: airdropImg,
      leftScale: leftScale,
      rightScale: rightScale,
      speedImg: speedImg1,
      speed: 0,
      height: 800,
      axisHeight: 282,
      axisInitHeight: 41,
      axisMinHeight: 1400,
      axisMinSpeed: 35,
      leftAxisStep: 1,
      rightAxisStep: 20,
      playOrPauseName: "播放",
    };
  },
  props: ["isHistory", "playOrPause", "replaySpeed", "taskPlan", "currentPoint"],
  methods: {
    //添加图片的事件监听
    initListeners() {
      const arrs = [
        "dashboardScale",
        "headingScale",
        "headingFlight",
        "pitch",
        "pointer",
        "rudder",
      ];
      for (let index = 0; index < arrs.length; index++) {
        const element = arrs[index];
        const obj = document.getElementById(element);
        const vue = this;
        obj.onload = (e) => {
          const id = e.currentTarget.getAttribute("id");
          vue.$data[id + "Flag"] = true;
          vue.doDrawChart();
        };
      }
    }, //初始时绘制仪表盘
    initChart() {
      this.doDrawChart();
    },
    doDrawChart() {
      const chart = document.getElementById("dashboardChart");
      if (chart) {
        const context = chart.getContext("2d");
        context.clearRect(0, 0, chart.width, chart.height);
        this.drawDashboard(context);
        this.drawHeading(context);
      }
    },
    drawDashboard(context) {
      if (this.$data.dashboardScaleFlag) {
        const dashboardScale = document.getElementById("dashboardScale");
        context.drawImage(dashboardScale, 0, 0);
        this.drawPitch(context);
        this.drawPointer(context);
        this.drawRudder(context);
      }
    },
    drawPitch(context) {
      if (this.$data.pitchFlag) {
        const pitch = document.getElementById("pitch");
        context.stroke();
        context.strokeStyle = "#00000000";
        context.save();
        context.beginPath();
        context.translate(99, 96);
        let rotate = (this.currentPoint.roll * Math.PI) / 180;
        context.rotate(rotate);
        context.arc(0, 0, 81, 0, Math.PI * 2, false);
        context.clip();
        const moveHeight = (this.currentPoint.pitch / 10) * 26;
        context.drawImage(pitch, -pitch.width / 2, -pitch.height / 2 + moveHeight);
        context.restore();
      }
    },
    drawPointer(context) {
      if (this.$data.pointerFlag) {
        const pointer = document.getElementById("pointer");
        context.stroke();
        context.save();
        context.translate(93 + pointer.width / 2, 24 + pointer.height / 2);
        let rotate = (this.currentPoint.roll * Math.PI) / 180;
        context.rotate(rotate);
        context.drawImage(pointer, -pointer.width / 2, -pointer.height / 2);
        context.restore();
      }
    },
    drawRudder(context) {
      if (this.$data.rudderFlag) {
        const rudder = document.getElementById("rudder");
        context.drawImage(rudder, 78, 96);
      }
    },
    drawHeading(context) {
      if (this.$data.headingScaleFlag) {
        const headingScale = document.getElementById("headingScale");
        context.drawImage(headingScale, 56, 199);
        this.drawChartFlight(context);
      }
    },
    drawChartFlight(context) {
      if (this.$data.headingFlightFlag) {
        const headingFlight = document.getElementById("headingFlight");
        context.stroke();
        context.save();
        context.translate(
          56 + headingScale.width / 2,
          199 + (headingScale.height - 5) / 2
        );
        let heading = ((this.currentPoint.heading - 90) * Math.PI) / 180;
        context.rotate(heading);
        context.drawImage(
          headingFlight,
          -headingFlight.width / 2,
          -headingFlight.height / 2
        );
        context.restore();
      }
    },
    unlock() {},
    takeOff() {},
    alternateLand() {},
    uavReturn() {},
    land() {},
    hover() {},
    cruise() {},
    airdrop() {},
    resetSpeedArray(speed) {
      const speedArr = [];
      if (this.$data.axisMinSpeed < speed) {
        const axis = Math.floor(speed / 7) + this.$data.leftAxisStep;
        for (let index = 0; index < 8; index++) {
          speedArr[index] = index * axis;
        }
        this.$data.leftAxis = speedArr;
      }
      this.$data.speed = speed;
      const max = this.$data.leftAxis[7];
      document.getElementById("leftRealAxis").style.top =
        this.$data.axisInitHeight + ((max - speed) * this.$data.axisHeight) / max + "px";
    },
    resetHeightArray(height) {
      const heightArr = [];
      if (this.$data.axisMinHeight < height) {
        const axis = Math.floor(height / 7) + this.$data.rightAxisStep;
        for (let index = 0; index < 8; index++) {
          heightArr[index] = index * axis;
        }
        this.$data.rightAxis = heightArr;
      }
      this.$data.height = height;
      const max = this.$data.rightAxis[7];
      document.getElementById("rightRealAxis").style.top =
        this.$data.axisInitHeight + ((max - height) * this.$data.axisHeight) / max + "px";
    },
    endFly() {
      this.$emit("endFly");
    },
    pauseOrPlay() {
      this.$emit("pauseOrPlay");
    },
    setSpeed(speed) {
      this.$emit("changeSpeed", speed);
    },
  },
  mounted() {
    if (!this.$data.initFlag) {
      this.$data.initFlag = true;
      this.initListeners();
      this.initChart();
      this.resetSpeedArray(0);
      this.resetHeightArray(0);
    }
  },
  watch: {
    playOrPause(nval, oval) {
      if (nval) {
        this.$data.playOrPauseName = "暂停";
      } else {
        this.$data.playOrPauseName = "播放";
      }
    },
    currentPoint(nval, oval) {
      this.initChart();
      this.resetSpeedArray(nval.trueAirspeedM);
      this.resetHeightArray(nval.alt0);
    },
  },
  computed: {
    selectSpeedLabelOne() {
      if (this.replaySpeed == 1) {
        return true;
      }
      return false;
    },
    selectSpeedLabelTwo() {
      if (this.replaySpeed == 2) {
        return true;
      }
      return false;
    },
    selectSpeedLabelThree() {
      if (this.replaySpeed == 3) {
        return true;
      }
      return false;
    },
  },
  components: {},
  beforeDestroy() {},
};
</script>

<style scoped>
@import "../../../assets/css/home/flightDetail/flightDetailRealTime.css";
</style>



// WEBPACK FOOTER //
// src/components/home/flightDetail/flightDetailRealTime.vue